export class BasicFieldConfig {
  field: string // name of the field
  header: string // displayName
  mandatory = false
  defaultValue: string // if not editable, then it might still get a value during creation
  type: string // String, int, boolean, float, Date, Icon, Color, Currency, Multiline, SelectList
  referenceType: string // <DTOType>
  referenceFilter: string // additional Filter when browsing the references;
  referenceSoftFilter: string
  listType: string // in case of type "SelectList" a listType is set, eg. "Reference"
  defaultCatalogue: string // if entitiy field is of type CatalogueEntry, then this field holds the name of the default catalogue to use
  editable: boolean
  showOnUpdate: boolean // field should be displayed when updating entities
  showOnCreate: boolean // field should be displayed when creating entities
  fieldDescription: string // description displayed in tooltip
  headerTooltip: string
}

export class Field extends BasicFieldConfig {
  visible: boolean
  sortable: boolean
  filterType: string
  width: string
  options: Option[]
  formula: string
  decimals: number // number of decimals for float type
  catalogueExpression: string
  evaluateFieldsOnChange: string[] // if set with a list of other field names, the GUI will reevaluate the other field's default values.
  editWizard: string // if set, editing the field will open the specified wizard

  public static isCatalogueEntry(field: Field): boolean {
    return field.type === 'Reference' && field.referenceType === 'CatalogueEntry'
  }

  public static isEntityReference(field: Field): boolean {
    return field.type === 'Reference' && field.referenceType !== 'CatalogueEntry'
  }

  public static isDtoType(field: Field): boolean {
    return field.type === 'dtoType'
  }

  public static isIcon(field: Field): boolean {
    return field.type === 'Icon'
  }

  public static isReference(field: Field): boolean {
    return field.type === 'Reference'
  }

  public static isState(field: Field): boolean {
    return field.type === 'State'
  }

  public static isMultiselect(field: Field): boolean {
    return field.type === 'Multiselect'
  }
}

class Option {
  label: string
  value: any
}
